


































































































































































































































































































































































































































































































































































































































































































































































































































/** @format */
import * as _ from 'lodash';
import FileImportMixin from '@root/common/mixins/import/import.tsx';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import ModalConfig from '@/components/modal-config/index.vue';
import TableWidthMixin from '@/common/mixins/table-width';
import Utils from '@root/utils/common';
import { LONG_RENTAL_CAR_RENEW, LONG_RENTAL_CAR_NEW, LONG_RENTAL_CAR_DETAIL } from '../router-names';
import ControlCarInfo from '../compontents/ControlCarInfo.vue';
import {
  longRentalCarTypeMap,
  longRentalStatusMap,
  TraderecordPayMethodsMap,
  gudMethodsMap
} from '../../../types/fixed-car-management/dictionaries';
import {
  queryMonthCardBuy,
  queryMonthCardList,
  queryMonthCardStop,
  quertMonthCardRefund,
  exportPropertyExcelExport,
  exportMonthExcelExport,
  querydownMenu,
  detailMenu, //详情
  freezeMenu, //冻结
  unfreezeMenu, //解冻
  refundMenu, //退款金额
  downloadTemplate,
  downloadlongrentErrorExcelExport,
  monthCardCheck,
  refundByList,
  spacePackageSelectLists
} from '@/api/fixed-car-management';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import PlateInput from '@/components/plate-input/index.vue';
import moment from 'moment';
import { Getter } from 'vuex-class';
import { CHARGING_PACKAGE_DETAIL, PARKING_SPACE_DETAIL } from '../../parking-space-management/router-names';
// axios请求
import { getRegion } from '@/api/parking-lot-management/index';
import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
import 'moment/locale/zh-cn';

import { isChangcheng, isShiDaill } from '@root/utils/env';

moment.locale('zh-cn');
// form表单项定义
export interface IForm {
  endDate: any;
  refundPrice: string;
  payType: string;
  payeeName: string;
  parkType: string;
  deviceProvider: string;
  bankAccount: any;
  payeeAccount: string;
}
@Component({
  name: 'longRentalCarList',
  components: {
    ParkingLotSearch,
    ControlCarInfo,
    PlateInput,
    ModalConfig,
    VNodes: {
      functional: true,
      render: (h: any, ctx: { props: { vnodes: any } }) => ctx.props.vnodes
    }
  }
})
// @Component
export default class longRentalCarList extends Mixins(TableMixin, TableWidthMixin, FileImportMixin) {
  locale = zhCN;
  //判断是否是时代邻里
  isShiDaill: boolean = isShiDaill;
  wenlv: boolean = 'wenlv,wenlvtest'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV);
  //判断是否是长城环境
  isChangCheng: boolean = isChangcheng;
  /**
   * 退费异步弹框
   */
  confirmRefundLoading = false;
  refundDetail: any = {
    cardId: '',
    endDate: null
  };
  needRefundMethod: boolean = true;
  // 长城
  cardIdchangcheng: '' | undefined;
  getCurrentStyle(
    current: {
      date: () => number;
    },
    today: any
  ) {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }
  // 冻结设置弹框
  mode2 = ['month', 'month'];
  frozenSet: Boolean = false;
  frozenSetForm: any = {};
  frozenDateTime: any[] = [];
  frozenLoadingsub = false;
  downloadLoading: boolean = false;
  refundMethod: boolean = true;

  filterOptionT(input: string, option: { componentOptions: { children: { text: string }[] } }) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  // 保存冻结设置弹框
  async handleSubmitfrozenSet() {
    if (this.frozenLoadingsub) return;
    this.frozenLoadingsub = true;
    // console.log(this.frozenDateTime, moment(this.frozenDateTime[0]._d).format('YYYY-MM'),moment(this.frozenDateTime[1]._d).format('YYYY-MM'))
    let freezeStartDate;
    let freezeEndDate;
    if (this.frozenDateTime[0] && this.frozenDateTime[1] && this.frozenDateTime[0]._d && this.frozenDateTime[1]._d) {
      freezeStartDate = moment(this.frozenDateTime[0]._d).format('YYYY-MM-DD');
      freezeEndDate = moment(this.frozenDateTime[1]._d)
        .endOf('month')
        .format('YYYY-MM-DD');
    } else {
      freezeStartDate = '';
      freezeEndDate = '';
    }
    try {
      const res = await freezeMenu({
        cardId: this.cardIdCh,
        freezeStartDate,
        freezeEndDate
      });
      this.frozenSet = false;
      this.fetchTableData();
      this.$message.success('冻结成功');
      this.freezeStatus = '';
    } catch (e) {
      this.$message.error(e.msg || '冻结失败');
    } finally {
      this.frozenLoadingsub = false;
    }
  }
  freezeStatus = '';
  // 关闭冻结设置弹框
  frozenClose() {
    this.frozenSet = false;
    this.freezeStatus = '';
  }
  cardIdCh = '';
  // 显示冻结设置弹框
  showfrozen(row: any) {
    if (row.lockingStatus == '02')
      return this.$message.error('您操作的业务下有未完成的订单，请先前往在线缴费订单中处理关联订单');
    this.cardIdCh = row.cardId;
    this.frozenSet = true;
    this.detailShow(row.cardId);
  }
  // 冻结设置详情数据
  detailList: any = {
    parkName: '',
    plates: '',
    freezeStartDate: '',
    freezeEndDate: '',
    freezeTime: '',
    beforeFreezeDate: '',
    afterFreezeDate: ''
  };
  detailList1: any = {
    parkName: '',
    plates: '',
    freezeStartDate: '',
    freezeEndDate: '',
    freezeTime: '',
    beforeFreezeDate: '',
    afterFreezeDate: ''
  };
  dateTime = null;
  // dateTime = [moment('2020-06', 'YYYY-MM'), moment('2020-06', 'YYYY-MM-DD')]
  dataErrList: any[] = [];
  // 冻结设置详情
  async detailShow(cardId) {
    try {
      const res = await detailMenu({ cardId });
      if (res.data && res.data.freezeStartDate && res.data.freezeEndDate) {
        this.detailList = res.data;
        this.detailList1 = res.data;
        this.dateTime = [moment(res.data.freezeStartDate, 'YYYY-MM-DD'), moment(res.data.freezeEndDate, 'YYYY-MM-DD')];
        this.frozenDateTime = [
          moment(res.data.freezeStartDate, 'YYYY-MM-DD'),
          moment(res.data.freezeEndDate, 'YYYY-MM-DD')
        ];
        console.log(this.dateTime);
        this.freezeStatus = res.data.freezeStatus;
      } else {
        this.detailList = {
          ...res.data,
          freezeStartDate: '',
          freezeEndDate: ''
        };
        this.dateTime = [];
        this.frozenDateTime = [];
      }
      console.log(res);
    } catch (e) {
      console.log(e);
      this.$message.error(e.msg);
    }
  }
  // 时间改变
  handleChangeDateTime(e: any, str: string) {
    // console.log(e , str,'e--------------')
    let str1 = str[0].split('-');
    let str2 = str[1].split('-');
    let start = moment(str1);
    let end = moment(str2);
    // console.log('end?????????????????????????',end)
    let n = end.diff(start, 'months');
    this.detailList.freezeTime = n + 1;
    // console.log(new Date(str[0]).getTime(), new Date(this.detailList.afterFreezeDate).getTime(), '-------------->???')
    // console.log(moment(str[0]).format('YYYY-MM-DD').getTime() , this.detailList.afterFreezeDate.getTime(),'--??????????>>>>>>>>>>>>>>>>>>>>')
    const date = moment(this.detailList.oldEndTime).add(n + 1, 'months');
    if (new Date(str[0]).getTime() < new Date(this.detailList.oldEndTime).getTime()) {
      this.detailList.afterFreezeDate = moment(date).format('YYYY-MM-DD');
    } else {
      if (str[0] !== '') {
        return this.$message.warning('冻结期限超出，请重新设置');
      } else {
        this.detailList.afterFreezeDate = moment(date).format('YYYY-MM-DD');
      }
    }
  }
  handlePanelChange2(value, mode) {
    this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]];
  }
  disabledDateds(current: any) {
    if (
      current.startOf('day').format('YYYY-MM-DD HH:mm:ss') ===
      moment(current)
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss')
    ) {
      // console.log(1111)
      return (
        false ||
        (current && current <= moment().startOf('day')) ||
        current > moment(this.refundDetail.endDate, 'YYYY-MM-DD').add(1, 'day')
      );
    } else {
      return (
        true ||
        (current && current <= moment().startOf('day')) ||
        current > moment(this.refundDetail.endDate, 'YYYY-MM-DD').add(1, 'day')
      );
    }
    // return (
    //   (current && current <= moment().startOf('day')) ||
    //   current > moment(this.refundDetail.endDate, 'YYYY-MM-DD').add(1, 'day')
    // )
  }
  getRegionList: any[] = []; //省市区下拉框
  // 获取省市区
  async setRegionList() {
    try {
      const { status, msg, code, data } = await getRegion({ userId: '11' });
      // console.log(status, msg, code, data)
      if (status === '9999') {
        data.map(item => {
          if (item.children) {
            item.children &&
              item.children.map(i => {
                i && delete i.children;
              });
          }
        });
        this.getRegionList = data;
      }
    } catch (e) {
      console.log(e);
    }
  }
  bankAccountLoading = false;
  dropdownVisibleChange(open) {
    if (open) {
      this.bankAccountLoading = false;
    }
  }
  // 银行开户行级联菜单
  getdownMenuList: any[] = [];
  async setquerydownMenu(pro, sh) {
    try {
      const res = await querydownMenu({ provinceName: pro, cityName: sh });
      if (res.data) {
        this.getdownMenuList = res.data.map(item => {
          return { label: item.bankName, value: item.bankNo };
        });
      }
    } catch (e) {
      console.log(e);
    }
  }
  changebank(e, selectedOptions) {
    if (selectedOptions) {
      this.setquerydownMenu(selectedOptions[0].label, selectedOptions[1].label); //获取银行
    }
    this.bankAccountLoading = true;
    // console.log(selectedOptions[0].label, selectedOptions[1].label)

    // this.setquerydownMenu(selectedOptions[0].label, selectedOptions[1].label)
  }
  // 解冻设置弹框
  unfreeze: Boolean = false;
  unfreezeForm: any = {};
  unfreezeLoadingsub = false;
  async handleSubmitunfreeze() {
    if (this.unfreezeLoadingsub) return;
    this.unfreezeLoadingsub = true;
    try {
      const res = await unfreezeMenu({ cardId: this.cardIdCh });
      console.log(res);
      this.unfreeze = false;
      this.fetchTableData();
      this.$message.success('解冻成功');
      this.freezeStatus = '';
    } catch (e) {
      console.log(e);
      this.$message.error(e.msg || '解冻失败');
    } finally {
      this.unfreezeLoadingsub = false;
    }
  }
  // 关闭冻结设置弹框
  unfreezeClose() {
    this.unfreeze = false;
  }
  // 显示冻结设置弹框
  showunfreeze(row: any) {
    this.unfreeze = true;
    this.frozenSet = false;
    this.freezeStatus = '';
  }
  // 支付方式
  // traderecordPayMethodsList = Utils.toLabelVal(TraderecordPayMethodsMap)
  @Getter('dictionaries/newCardPaymentPayType')
  newCardPaymentPayType?: any;
  get traderecordPayMethodsList() {
    if (this.isChangCheng) {
      return Utils.toLabelVal(this.newCardPaymentPayType);
    } else if (this.isShiDaill && this.filterParam.useType === '02') {
      return _.filter(Utils.toLabelVal(this.newCardPaymentPayType), function(o) {
        o.label = `${o.label}`;
        return o.value != '02' && o.value != '03' && o.value != '05';
      });
    } else {
      return _.filter(Utils.toLabelVal(this.newCardPaymentPayType), function(o) {
        o.label = `${o.label}`;
        return o.value != '02' && o.value != '03';
      });
    }
  }
  // 退费方式
  gudMethodsList = Utils.toLabelVal(gudMethodsMap);

  // 车辆变更
  changeCar = false;
  returnAmount = false;
  form: any = null;
  changchengflag: Boolean = false;
  amount = '';
  changeParkingInfo: any[] = [
    {
      prop: 'parking',
      label: '车位编号：'
    },
    {
      prop: 'parking',
      label: '车主姓名：'
    },
    {
      prop: 'parking',
      label: '备注：'
    }
  ];
  cardList: any[] = [
    {
      value: '6666',
      prop: 'input',
      tagFlag: true
    }
  ];
  detailModel = {};
  private tableLoading = false;
  lodash = _;
  get basicInfo() {
    return this.tableColums.slice(1, -1).map(item => ({ label: item.title, prop: item.dataIndex }));
  }
  filterParam: any = {
    useType: '02',
    parkId: [],
    codeF: '',
    userType: '01',
    userValue: '',
    plateHead: '',
    plateTail: '',
    statusF: [],
    expire: '',
    startDateOrderBy: '',
    endDateOrderBy: '',
    groupId: '',
    groupName: '',
    packageId: []
  };
  clearPlate: boolean = false;
  clear({ defaultParkIdList }) {
    this.clearPlate = true;
    this.filterParam = {
      useType: '02',
      parkId: defaultParkIdList,
      codeF: '',
      userType: '01',
      userValue: '',
      plateHead: '',
      plateTail: '',
      statusF: [],
      expire: '',
      startDateOrderBy: '',
      endDateOrderBy: '',
      packageId: []
    };
    this.search();
  }
  refund = {
    payType: '01',
    refundPrice: '0',
    refundPriceErr: true,
    endDate: null,
    endDateErr: true
  };
  refundForm: any;
  created() {
    this.fetchTableData();
    this.setRegionList(); //获取省市区
    // this.setquerydownMenu() //获取银行
  }

  activated() {
    if (this.$route.query.parkDay) {
      this.filterParam.expire = this.$route.query.parkDay;
    }
    if (this.$route.query.parkId) {
      this.filterParam.parkId = this.$route.query.parkId;
    }
  }

  private search() {
    this.current = 1;
    this.fetchTableData();
  }
  public async fetchTableData() {
    this.selectedRowKeys = [];
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const {
        useType,
        parkId,
        codeF,
        userType,
        userValue,
        plateHead,
        plateTail,
        statusF,
        expire,
        startDateOrderBy,
        endDateOrderBy,
        groupName,
        groupId,
        packageId
      } = this.filterParam;
      if (plateTail && plateHead === '') {
        return this.$message.error('请先选择省份再进行查询');
      }
      const { status, msg, code, data } = await queryMonthCardList({
        parkId: '' + parkId,
        userType,
        useType,
        code: codeF,
        userValue,
        plateHead,
        plateTail,
        status: '' + statusF,
        expire,
        currPage: this.current,
        pageSize: this.pageSize,
        startDateOrderBy,
        endDateOrderBy,
        groupName,
        groupId,
        packageId: '' + packageId
      });
      if (data) {
        const { pageSize, currPage, totalPage, totalNum, datas = [], total } = data;
        this.total = Number(totalNum);
        if (datas.length > 0) {
          this.tableData = datas;
        } else {
          this.tableData = [];
        }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryMonthCardList  接口调用错误', error);
    } finally {
      this.tableLoading = false;
    }
  }
  async download() {
    const {
      useType,
      parkId,
      codeF,
      userType,
      userValue,
      plateHead,
      plateTail,
      statusF,
      expire,
      startDateOrderBy,
      endDateOrderBy,
      groupName,
      groupId,
      packageId
    } = this.filterParam;

    if (plateTail && plateHead === '') {
      return this.$message.error('请先选择省份再进行查询');
    }
    let exportMap = {
      parkId: '' + parkId,
      useType,
      code: codeF,
      userType,
      userValue,
      plateHead,
      plateTail,
      status: '' + statusF,
      expire,
      startDateOrderBy,
      endDateOrderBy,
      groupName,
      groupId,
      packageId: '' + packageId
    };
    try {
      await exportMonthExcelExport(exportMap, '长租车业务办理');
    } catch (e) {
      this.$message.error((e && e.msg) || '系统错误，请稍后重试');
    }
  }
  // 车牌号
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  preventDefault(item: any) {
    // e.preventDefault()
    item.tagFlag = false;

    console.log('Clicked! But prevent default.', item);
  }
  /**
   * 调用停租
   */
  private async queryMonthCardStopClick(record: any) {
    if (record.lockingStatus == '02')
      return this.$message.error('您操作的业务下有未完成的订单，请先前往在线缴费订单中处理关联订单');
    this.$confirm({
      title: `确定停租？`,
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        const load: any = this.$message.loading('正在停租');
        try {
          const { status, msg, date } = await queryMonthCardStop({ cardId: record.cardId });
          if (status === '9999') {
            this.$message.success('停租成功');
            this.fetchTableData();
          } else {
            this.$message.error('停租失败');
          }
        } catch (e) {
          console.log('queryMonthCardStop   接口错误');
        } finally {
          load();
        }
      },
      onCancel() {}
    });
  }
  // 授权状态
  // stateType = Utils.toLabelVal(longRentalStatusMap)
  stateType = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.month_card_status);

  // 车位类别
  carType = Utils.toLabelVal(longRentalCarTypeMap);
  tableData: any[] = []; // 表数据
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        width: 180,
        dataIndex: 'parkName',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '收费套餐',
        width: 180,
        dataIndex: 'packageName',
        scopedSlots: { customRender: 'to-package-detail' }
      },
      {
        title: '车位号',
        dataIndex: 'code',
        width: 140,
        scopedSlots: { customRender: 'to-parking-space-detail' }
      },
      {
        title: '所属区域',
        dataIndex: 'area',
        width: 150,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 150,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '车位类型',
        width: 140,
        dataIndex: 'category',
        scopedSlots: { customRender: 'category' }
      },
      {
        title: '泊车数量',
        dataIndex: 'parkingNum',
        width: 140,
        customRender: (text: any) => {
          if (text !== 'null') {
            return `${text}个`;
          }
          return '--';
        }
      },
      {
        title: '授权期起',
        width: 160,
        dataIndex: 'startDate',
        sortable: true
      },
      {
        title: '授权期止',
        width: 160,
        dataIndex: 'endDate',
        sortable: true
      },
      {
        title: '授权状态',
        width: 140,
        dataIndex: 'statusString'
      },
      {
        title: '姓名',
        width: 140,
        dataIndex: 'userName',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '单位',
        width: 140,
        dataIndex: 'company',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '房号/住址',
        width: 140,
        dataIndex: 'roomNum',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '电话',
        width: 160,
        dataIndex: 'phoneNum'
      },
      // {
      //   title: '月卡状态',
      //   width: 160,
      //   dataIndex: 'lockingStatusStr',
      // },
      {
        title: '车位组编号',
        dataIndex: 'groupId',
        width: 220,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '车位组名称',
        dataIndex: 'groupName',
        width: 150,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 280,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  // 退费日期
  // onChangeRefundTime(date: any, dateString: any) {
  //   console.log(dateString)
  //   this.refund.endDate = dateString
  // }
  private moment = moment;
  disabledDate(current: any) {
    return (
      (current && current <= moment().startOf('day')) ||
      current > moment(this.refundDetail.endDate, 'YYYY-MM-DD').add(1, 'day')
    );
  }
  endDateTimes = '';
  startDateTimes = '';
  disabledDateT(current: any) {
    return (
      (current && current <= moment().startOf('day')) ||
      current > moment(this.refundDetail.endDate, 'YYYY-MM-DD') ||
      current > moment(this.endDateTimes, 'YYYY-MM-DD') ||
      current < moment(this.startDateTimes, 'YYYY-MM-DD')
      // .subtract(1, 'day')
    );
  }
  /**
   * 去续费
   */
  toRenew(item: any) {
    if (item.lockingStatus == '02')
      return this.$message.error('您操作的业务下有未完成的订单，请先前往在线缴费订单中处理关联订单');
    this.$router.push({
      name: LONG_RENTAL_CAR_RENEW,
      query: {
        cardId: item.cardId,
        useType: '02',
        status: item.status
      }
    });
  }

  // 初始化form表单
  init() {
    this.form = this.$form.createForm(this);
  }
  /**
   * 去办卡
   */
  toNewCard() {
    this.$router.push({
      name: LONG_RENTAL_CAR_NEW,
      query: {
        useType: '02'
      }
    });
  }

  //弹窗关闭
  changeCarOK() {
    this.changeCar = false;
    this.returnAmount = false;
  }

  //弹窗关闭
  changeCarCancel() {
    this.refund = {
      payType: '01',
      refundPrice: '0',
      refundPriceErr: true,
      endDate: null,
      endDateErr: true
    };
    this.changeCar = false;
    this.returnAmount = false;
  }
  changchengclose() {
    this.changeCar = false;
    this.changchengflag = false;
    this.getdownMenuList = [];
  }

  async endDateChange(e, str) {
    try {
      const res = await refundMenu({
        monthCardId: this.cardIdchangcheng,
        refundDate: str
      });
      this.form.setFieldsValue({
        refundPrice: (res.data.price / 100).toFixed(2)
      });
    } catch (e) {
      console.log(e);
    }
  }
  //  // // 长城退费确认
  confirmLoadingsub = false;
  async changchengOk(e: any) {
    e.stopPropagation();
    e.preventDefault();
    if (this.confirmLoadingsub) return;
    this.confirmLoadingsub = true;
    this.form.validateFields(async (err: boolean, values: IForm) => {
      values.endDate = moment(values.endDate).format('YYYY-MM-DD');
      try {
        const res = await quertMonthCardRefund({
          ...values,
          cardId: this.cardIdchangcheng
        });
        console.log(res);
        this.fetchTableData();
        this.changchengflag = false;
        this.$message.success(e.msg || '退款成功');
        this.getdownMenuList = [];
      } catch (e) {
        console.log(e);
        this.$message.error(e.msg || '退款失败');
      } finally {
        this.confirmLoadingsub = false;
      }
    });
  }
  /**
   * 退费弹框
   * 在这边改 是不是长城的退费
   */
  refundClick(item: any) {
    if (item.lockingStatus == '02')
      return this.$message.error('您操作的业务下有未完成的订单，请先前往在线缴费订单中处理关联订单');
    if (item.refundMethod && item.refundMethod === '00') {
      this.needRefundMethod = false;
    }
    this.endDateTimes = item.endDate;
    this.startDateTimes = item.startDate;
    // @ts-ignore
    if (this.isChangCheng) {
      this.refundMethod = item.refundMethod === '00' ? false : true;
      this.changchengflag = true;
      this.cardIdchangcheng = item.cardId;
      this.init();
    } else {
      this.returnAmount = true;
      const { cardId, endDate } = item;
      this.refundDetail = { cardId, endDate };
    }
  }

  /**
   *
   */
  private async changeRefundOK() {
    this.confirmRefundLoading = true;
    try {
      let { cardId } = this.refundDetail;
      let { payType, refundPrice, endDate, refundPriceErr, endDateErr } = this.refund;
      if (!endDate) {
        this.refund.endDateErr = false;
      } else {
        this.refund.endDateErr = true;
      }
      if (!refundPrice) {
        this.refund.refundPriceErr = false;
      } else {
        this.refund.refundPriceErr = true;
      }
      if (!this.refund.refundPriceErr || !this.refund.endDateErr) {
        return false;
      }
      const { status, msg, data } = await quertMonthCardRefund({
        cardId,
        payType,
        refundPrice: Number(refundPrice).toFixed(2),
        endDate: moment(endDate).format('YYYY-MM-DD')
      });
      if (status === '9999') {
        //this.returnAmount = false
        this.changeCarCancel();
        this.$message.success(data);
        this.fetchTableData();
      } else {
        this.$message.error(msg);
      }
    } catch (e) {
      if (e.msg) {
        this.$message.error(e.msg);
      }
    } finally {
      this.confirmRefundLoading = false;
    }
  }
  handleNumberChange(e: any) {
    this.refund.refundPrice = e.target.value.replace(/[^\d.]/g, '');
  }
  // 下载导入模板
  async downLoadTemplate() {
    try {
      this.downloadLoading = true;
      await downloadTemplate({}, '长租车导入模板');
    } catch (e) {
      console.log('下载失败');
    } finally {
      this.downloadLoading = false;
    }
  }
  tableVisiter = false;
  errMsg = false;
  keyword = '';
  downLoadErrMsgLoading = false;
  errMsgdes = '';
  // 导入弹框
  showTableErr(e) {
    try {
      // console.log(e, 'error---------->')
      this.tableVisiter = true;
      this.errMsg = true;
      // this.dataErrList = e.data
      this.keyword = e.data;
      this.errMsgdes = e.msg;
    } catch (e) {
      console.log(e);
    }
  }
  handleCancel() {
    this.tableVisiter = false;
  }
  showBtnErr(e) {
    this.errMsg = true;
    console.log(e);
    this.keyword = e.data;
    this.errMsgdes = e.msg;
  }
  renderFetchTableData() {
    this.fetchTableData();
    this.tableVisiter = false;
  }
  async downLoadErrMsg() {
    try {
      if (this.downLoadErrMsgLoading) return;
      this.downLoadErrMsgLoading = true;
      const res = await downloadlongrentErrorExcelExport({
        useType: '02',
        keyword: this.keyword
      });
      console.log(res);
    } catch (e) {
      console.log(e);
    } finally {
      this.downLoadErrMsgLoading = false;
    }
  }
  //详情
  toRenewDetail(cardId: any, isDetail: any) {
    this.$router.push({
      name: LONG_RENTAL_CAR_DETAIL,
      query: {
        cardId,
        useType: '01',
        isDetail: isDetail
      }
    });
  }

  // 去套餐详情
  private toPackageDetail(id: string) {
    this.$router.push({
      name: CHARGING_PACKAGE_DETAIL,
      params: {
        id
      }
    });
  }

  // 去车位详情
  private toParkingSpaceDetail(id: string) {
    this.$router.push({
      name: PARKING_SPACE_DETAIL,
      params: {
        id
      }
    });
  }

  deleteVisibale: boolean = false; //删除一级弹框
  canDeleteNum: number = 0; //可删除车位的数量
  notDeleteList: any[] = []; //不可删除的列表
  selectedRowKeys: any = [];
  deleteFlag: boolean = false;
  deleteBtnFlag: boolean = false;
  canDeleteList: any[] = [];
  onSelectChange(selectedRowKeys) {
    // console.log('selectedRowKeys changed: ', selectedRowKeys)
    this.selectedRowKeys = selectedRowKeys;
  }
  //确认删除
  async onMultiClearClick(recordCollection: any[] = []) {
    const _self = this;
    //this.tableLoading = true
    try {
      // await spaceDelete({ spaceIds: _self.selectedRowKeys })
      _self.fetchTableData();
      _self.selectedRowKeys = [];
    } catch (e) {
      console.log(e);
    } finally {
      // _self.tableLoading = false
    }
  }
  //
  async deleteTip() {
    try {
      this.deleteBtnFlag = true;
      const { data } = await monthCardCheck({
        monthCardIds: this.selectedRowKeys
      });
      const { errorList, monthCardIds } = data;
      this.notDeleteList = errorList;
      this.canDeleteNum = monthCardIds.length || '0';
      this.canDeleteList = monthCardIds || [];
      // this.deleteVisibale = true
      if (this.canDeleteList.length == this.selectedRowKeys.length) {
        this.showConfirm();
      } else {
        this.deleteVisibale = true;
      }
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.deleteBtnFlag = false;
    }
  }
  //取消退费
  cancelDelete() {
    this.deleteVisibale = false;
  }
  //再次确认是否删除
  showConfirm() {
    const self = this;
    this.$confirm({
      title: '提示',
      content: `即将一键退费并删除${this.canDeleteNum}条数据，请确认是否继续`,
      async onOk() {
        if (self.deleteFlag) return;
        //
        self.deleteFlag = true;
        try {
          await refundByList({ monthCardIds: self.canDeleteList });
          self.selectedRowKeys = [];
          self.$message.success('删除成功');
          self.fetchTableData();
          self.cancelDelete();
        } catch (e) {
          console.log('报错==>', e);
          self.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
        } finally {
          self.deleteFlag = false;
        }
      },
      onCancel() {}
    });
  }
  /**
   * 表头筛选
   */
  onSortChange({ sortList = [], property, order }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    if (!order) {
      this.filterParam[`${property}OrderBy`] = '';
    }
    this.current = 1;
    this.fetchTableData();
  }
  changeParkId(value: string[]) {
    if (value.length > 0) {
      this.spacePackageSelectList();
    } else {
      this.monthCardPackage = [];
    }
  }

  // 初始化接口 获取月卡套餐
  monthCardPackage: any = [];
  async spacePackageSelectList() {
    try {
      const { parkId, useType } = this.filterParam;
      const { status, msg, data = [] } = await spacePackageSelectLists({
        parkId: '' + parkId,
        useType
      });
      if (status === '9999') {
        this.monthCardPackage = data;
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }
}
